import $ from 'jquery';
import buttonsGetLine from '../Button/buttonsGetLine';

export default (container = document) => {
  $('[data-featured-articles-content]', container).each((i, content) => {
    const $content = $(content);
    let preheading = $content.find('[data-preheading]').html();
    let heading = $content.find('[data-heading]').html();
    const $button = $content.find('[data-button]');

    if ($button.length > 0 && $.trim($button.html()) !== '') {
      const $destination = $button.parents().find('[data-button-destination]');

      $button.addClass('Button').addClass('Button--primary');
      $button.appendTo($destination);
      $button.wrap('<div class="Section__button-container Animate Animate--slide-up"></div>');
      buttonsGetLine('[data-button-destination]');
    }

    $content.html('');

    if (preheading) {
      preheading = `<div class="Section__preheading angled-eyebrow">${preheading}</div>`;
      $content.append(preheading);
    }

    if (heading) {
      heading = `<h3 class="Section__heading">${heading}</h3>`;
      $content.append(heading);
    }

  });
};